import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) {
  }

  public post<T>(url: string, data: any, headers?: HttpHeaders, params?: HttpParams, ignoreLoading?: boolean) {
    params = this.setIgnoreLoading(ignoreLoading, params);
    return this.http.post<T>(`${environment.api}/${url}`, data, { headers, params });
  }

  public postCustomApi<T>(url: string, data: any, headers?: HttpHeaders, params?: HttpParams) {
    return this.http.post<T>(url, data, { headers, params })
  }

  public get<T>(url: string, params?: HttpParams, headers?: HttpHeaders, ignoreLoading?: boolean) {
    params = this.setIgnoreLoading(ignoreLoading, params);
    return this.http.get<T>(`${environment.api}/${url}`, { params: params, headers: headers });
  }

  public getCustomApi<T>(url: string, params?: HttpParams, headers?: HttpHeaders) {
    return this.http.get<T>(url, { params, headers });
  }

  public put<T>(url: string, data?: any, headers?: HttpHeaders, ignoreLoading?: boolean, params?: HttpParams) {
    params = this.setIgnoreLoading(ignoreLoading, params);
    return this.http.put<T>(`${environment.api}/${url}`, data, { headers, params })
  }

  public delete<T>(url: string, data?: any, ignoreLoading?: boolean) {
    const params = this.setIgnoreLoading(ignoreLoading);
    return this.http.request('DELETE', `${environment.api}/${url}`, {
      body: data,
      params
    });
  }

  public deleteCustomApi<T>(url: string, data?: any) {
    return this.http.request('DELETE', url, {
      body: data
    });
  }

  public patch<T>(url: string, data?: any, ignoreLoading?: boolean, params?: HttpParams, headers?: HttpHeaders) {
    params = this.setIgnoreLoading(ignoreLoading, params);
    return this.http.patch<T>(`${environment.api}/${url}`, data, { headers, params })
  }

  public download(url: string, data?: any) {
    return this.http.post(`${environment.api}/${url}`, data, { responseType: "blob", observe: 'response' })
  }

  public downloadPost(url: string, data?: any, p0?: { headers: HttpHeaders; responseType: "json"; observe: string; }) {
    return this.http.post(`${environment.api}/${url}`, data, { responseType: "blob", observe: 'response' })
  }

  public downloadGet(url: string, headers?: HttpHeaders) {
    return this.http.get(`${environment.api}/${url}`, { responseType: "blob", observe: 'response', headers })
  }

  public downloadVideo(url: string, headers?: HttpHeaders) {
    return this.http.get(`${environment.api}/${url}`, { responseType: "blob", observe: 'response', headers })
  }

  public convertObjectToParams(obj: any): HttpParams {
    let params = new HttpParams()
    if (obj === null || obj === undefined)
      return params;

    Object.keys(obj).filter(x => obj[x] != undefined && obj[x] != null && obj[x] != 'null' && obj[x] != '').forEach((x) => {
      params = params.set(x.toString(), obj[x]);
    })

    return params;
  }

  public removeNullPropertys<T>(obj: any): T {
    if (obj === undefined || obj === null || typeof obj !== 'object') {
      return {} as T;
    }

    const newObj: any = {};

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (value !== undefined && value !== null && value !== 'null' && value !== '') {
        if (Array.isArray(value) && value.length === 0) {
          newObj[key] = null;
        } else {
          newObj[key] = value;
        }
      }
    });

    return newObj as T;
  }


  public putCustomApi<T>(url: string, data?: any, headers?: HttpHeaders, params?: HttpParams) {
    return this.http.put<T>(url, data, { headers, params })
  }

  public postFile<T>(url: string, data: any, headers?: HttpHeaders, params?: HttpParams) {
    return this.http.post<T>(`${environment.api}/${url}`, data, { headers, params, reportProgress: true,
      observe: 'events' });
  }

  private setIgnoreLoading(ignoreLoading?: boolean, params?: HttpParams): HttpParams {
    if (ignoreLoading) {
      if (!params) {
        params = new HttpParams();
      }
      params = params.append('ignoreLoading', true);
    }

    return <HttpParams>params;
  }
}
